<template lang="pug">
.ovg-create-view

  //- Header
  .header-ovg.d-none.d-md-flex
    .title-section(@click="$router.push('/garantias-center')")
      b-icon.back-arrow(icon="arrow-left-square-fill")
      h4.title Creación OVG

  .breadcrumbs-ovg
    span.text-muted Inicio / Oportunidades de Venta / Garantías Extendidas OVG /&nbsp;
    span.text-dark Creación OVG

  .container-create
    .create-layout
      //- Columna izquierda: Wizard
      .wizard-column
        //- ─── PASO 1: Datos del Cliente ────────────────────────────────────────
        .step-card
          .step-header(@click="irAPaso(1)" :class="{ active: pasoActivo === 1 }")
            .step-number(:class="{ done: pasoMaxAlcanzado > 1 }")
              b-icon(v-if="pasoMaxAlcanzado > 1" icon="check-lg")
              span(v-else) 1
            .step-label Datos del Cliente
            b-icon.step-toggle(:icon="pasoActivo === 1 ? 'chevron-up' : 'chevron-down'")
          .step-body(v-show="pasoActivo === 1")
            b-row
              b-col(cols="12")
                b-form-group(label="RUT*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.rut"
                    placeholder="12345678-9"
                    :state="fieldState('rut')"
                  )
                  b-form-invalid-feedback {{ errors.rut }}
            b-row
              b-col(cols="12" md="6")
                b-form-group(label="Nombre*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.nombre"
                    :state="fieldState('nombre')"
                  )
                  b-form-invalid-feedback {{ errors.nombre }}
              b-col(cols="12" md="6")
                b-form-group(label="Apellido*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.apellido"
                    :state="fieldState('apellido')"
                  )
                  b-form-invalid-feedback {{ errors.apellido }}
            b-row
              b-col(cols="12" md="6")
                b-form-group(label="Correo Electrónico*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.correo"
                    type="email"
                    placeholder="ej:correo@mail.cl"
                    :state="fieldState('correo')"
                  )
                  b-form-invalid-feedback {{ errors.correo }}
              b-col(cols="12" md="6")
                b-form-group(label="Teléfono (Opcional)" label-class="samtek-label")
                  b-form-input(
                    v-model="form.telefono"
                  )
            .d-flex.justify-content-end.mt-3
              b-button.btn-step-primary(@click="avanzarPaso1") Siguiente Paso

        //- ─── PASO 2: Modelo de Equipo ──────────────────────────────────────────
        .step-card
          .step-header(@click="pasoMaxAlcanzado >= 2 && irAPaso(2)" :class="{ active: pasoActivo === 2, locked: pasoMaxAlcanzado < 2 }")
            .step-number(:class="{ done: pasoMaxAlcanzado > 2 }")
              b-icon(v-if="pasoMaxAlcanzado > 2" icon="check-lg")
              span(v-else) 2
            .step-label Modelo de Equipo
            b-icon.step-toggle(:icon="pasoActivo === 2 ? 'chevron-up' : 'chevron-down'" v-if="pasoMaxAlcanzado >= 2")
          .step-body(v-show="pasoActivo === 2")
            b-row
              b-col(cols="12" md="6")
                b-form-group(label="N° de Serie Equipo*" label-class="samtek-label")
                  b-form-input(
                    v-model="form.numero_serie"
                    placeholder="S/N 123456789"
                    :state="fieldState('numero_serie')"
                    maxlength="15"
                  )
                  b-form-invalid-feedback {{ errors.numero_serie }}
              b-col(cols="12" md="6")
                b-form-group(label="Fecha de Compra" label-class="samtek-label")
                  b-form-datepicker(
                    v-model="form.fecha_compra_equipo"
                    locale="es-CL"
                    :max="hoy"
                    :state="fieldState('fecha_compra_equipo')"
                    placeholder="Ingrese una fecha"
                    @input="onFechaCompraChange"
                  )
                  b-form-invalid-feedback {{ errors.fecha_compra_equipo }}
                  .text-muted.small.mt-1(v-if="form.fecha_compra_equipo && !equipoReciente")
                    b-icon(icon="info-circle")
                    |  El equipo tiene más de 180 días — no aplican protecciones adicionales.

            .modelo-grupo
              label.samtek-label Modelo del Equipo*
              .modelo-search-row
                b-form-input(
                  v-model="modeloQuery"
                  placeholder="Buscar modelo ..."
                  @input="onModeloSearch"
                  :disabled="modeloNuevo"
                )
                b-button.btn-crear-modelo(variant="outline-secondary" @click="activarModeloNuevo" v-if="!modeloNuevo && !modeloSeleccionado") Crear Nuevo Modelo
                b-spinner.ml-2(v-if="loadingModelos" small variant="secondary")
              .modelo-resultados(v-if="modeloResultados.length && !modeloNuevo")
                .modelo-item(
                  v-for="m in modeloResultados"
                  :key="m.id"
                  @click="seleccionarModelo(m)"
                  :class="{ selected: form.modelo_id === m.id }"
                ) {{ m.nombre || m.id }}
              .modelo-seleccionado(v-if="modeloSeleccionado && !modeloNuevo")
                b-badge(variant="primary" pill)
                  | {{ modeloSeleccionado.nombre || modeloSeleccionado.id }}
                  b-icon.ml-1(icon="x" @click="limpiarModelo" style="cursor:pointer")
              .modelo-seleccionado(v-if="modeloNuevo && form.modelo_nuevo_nombre")
                b-badge(variant="info" pill)
                  | {{ form.modelo_nuevo_nombre }}
                  b-icon.ml-1(icon="x" @click="cancelarModeloNuevo" style="cursor:pointer")
              .text-muted.small.mt-1(v-if="modeloQuery.length >= 2 && !loadingModelos && !modeloResultados.length && !modeloNuevo && !modeloSeleccionado")
                | No se encontraron modelos.
              .text-danger.small.mt-1(v-if="errors.modelo_id") {{ errors.modelo_id }}

            .boleta-upload-group.mt-3
              label.samtek-label.d-block.mb-2 Boleta*
              input(
                ref="boletaInput"
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                style="display:none"
                @change="onBoletaChange"
              )
              .boleta-dropzone(
                @dragover.prevent="boletaDragOver = true"
                @dragleave="boletaDragOver = false"
                @drop.prevent="onBoletaDrop"
                :class="{ 'is-dragover': boletaDragOver }"
              )
                template(v-if="!boletaFile")
                  b-icon.boleta-upload-icon(icon="cloud-upload" font-scale="2.5")
                  p.boleta-upload-text.mb-2 Arrastra y suelta tu archivo aquí.
                  b-button.btn-seleccionar-boleta(@click="$refs.boletaInput.click()") Seleccionar desde tu equipo
                  small.text-muted.mt-2.d-block Formatos aceptados: JPG, PNG o PDF. Peso máximo: 5 MB.
                template(v-else-if="boletaEsImagen")
                  img.boleta-img-preview(:src="boletaPreviewUrl" alt="Boleta")
                  b-button.btn-cambiar-boleta.mt-2(variant="link" size="sm" @click="$refs.boletaInput.click()")
                    b-icon(icon="pencil")
                    |  Cambiar imagen
                template(v-else)
                  b-icon(icon="file-earmark-pdf-fill" variant="danger" font-scale="3")
                  p.mt-2.mb-1.font-weight-600 {{ boletaFile.name }}
                  b-button.btn-cambiar-boleta.mt-1(variant="link" size="sm" @click="$refs.boletaInput.click()")
                    b-icon(icon="pencil")
                    |  Cambiar archivo
              .text-danger.small.mt-1(v-if="errors.boleta_cliente") {{ errors.boleta_cliente }}

            .d-flex.justify-content-end.mt-3
              b-button.btn-step-primary(@click="avanzarPaso2") Siguiente Paso

        //- ─── PASO 3: Extensión de Garantía ─────────────────────────────────────
        .step-card
          .step-header(@click="pasoMaxAlcanzado >= 3 && irAPaso(3)" :class="{ active: pasoActivo === 3, locked: pasoMaxAlcanzado < 3 }")
            .step-number(:class="{ done: pasoMaxAlcanzado > 3 }")
              b-icon(v-if="pasoMaxAlcanzado > 3" icon="check-lg")
              span(v-else) 3
            .step-label Extensión de Garantía
            b-icon.step-toggle(:icon="pasoActivo === 3 ? 'chevron-up' : 'chevron-down'" v-if="pasoMaxAlcanzado >= 3")
          .step-body(v-show="pasoActivo === 3")
            b-overlay(:show="loadingExtensiones" rounded="sm")
              .text-muted.small.mb-3(v-if="!loadingExtensiones && !extensiones.length")
                | No hay extensiones disponibles para este modelo.

              .garantias-grid
                .garantia-card(
                  v-for="g in extensiones"
                  :key="g.id"
                  :class="{ selected: form.garantia_id === g.id }"
                  @click="seleccionarExtension(g.id)"
                )
                  svg.garantia-icon(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                    path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .garantia-nombre {{ g.nombre }}
                  .garantia-desc {{ g.descripcion }}
                  .garantia-precio ${{ Number(g.precio).toLocaleString('es-CL') }}
                  b-button.btn-garantia.mt-2(block size="sm")
                    | {{ form.garantia_id === g.id ? 'Seleccionado' : 'Agregar al Carrito' }}

              b-alert.mt-2(v-if="errors.garantia_id" show variant="danger") {{ errors.garantia_id }}

              .mt-3
                b-button.btn-sin-extension(
                  block
                  :disabled="!equipoReciente"
                  v-b-tooltip.hover="!equipoReciente && form.fecha_compra_equipo ? 'Solo disponible para equipos comprados hace 180 días o menos.' : ''"
                  @click="seleccionarSinExtension"
                )
                  | Ir a Protección Adicional sin Extensión de Garantía

            .d-flex.justify-content-end.mt-3
              b-button.btn-step-primary(
                :disabled="!form.garantia_id || submitting"
                @click="avanzarPaso3"
              )
                b-spinner(v-if="submitting && !equipoReciente" small class="mr-2")
                | {{ (!equipoReciente && submitting) ? 'Creando...' : (equipoReciente ? 'Siguiente Paso' : 'Finalizar OVG') }}

        //- ─── PASO 4: Protecciones ─────────────────────────────────────────────
        .step-card(v-if="mostrarPaso4")
          .step-header(@click="pasoMaxAlcanzado >= 4 && irAPaso(4)" :class="{ active: pasoActivo === 4, locked: pasoMaxAlcanzado < 4 }")
            .step-number 4
            .step-label Protección Adicional
            b-icon.step-toggle(:icon="pasoActivo === 4 ? 'chevron-up' : 'chevron-down'" v-if="pasoMaxAlcanzado >= 4")
          .step-body(v-show="pasoActivo === 4")
            b-overlay(:show="loadingProtecciones" rounded="sm")
              .text-muted.small.mb-3(v-if="!loadingProtecciones && !protecciones.length")
                | No hay protecciones disponibles para la extensión seleccionada.

              .garantias-grid
                .garantia-card(
                  v-for="p in protecciones"
                  :key="p.id"
                  :class="{ selected: form.proteccion_ids.includes(p.id) }"
                  @click="toggleProteccion(p.id)"
                )
                  svg.garantia-icon(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                    path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                    path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .garantia-nombre {{ p.nombre }}
                  .garantia-desc {{ p.descripcion }}
                  .garantia-precio ${{ Number(p.precio).toLocaleString('es-CL') }}
                  b-button.btn-garantia.mt-2(block size="sm")
                    | {{ form.proteccion_ids.includes(p.id) ? 'Seleccionado' : 'Agregar al Carrito' }}

              b-alert.mt-2(v-if="errors.garantias" show variant="danger") {{ errors.garantias }}

              b-button.btn-continuar-sin-proteccion.mt-3(
                block
                @click="continuarSinProteccion"
              ) Continuar sin Protección Adicional

              .d-flex.justify-content-end.mt-3
                b-button.btn-step-primary(
                  @click="avanzarPaso4"
                ) Siguiente Paso

        //- ─── PASO 5: Confirmación (Resumen Solicitud + Resumen Pago) ─────────
        .step-card(v-if="pasoActivo === 5")
          .step-body.resumen-solicitud-body
            .resumen-solicitud
              //- Título + descripción
              .resumen-solicitud-header
                h2.resumen-solicitud-title Resumen Solicitud
                p.resumen-solicitud-desc Revisa los detalles de tu garantía seleccionada y envía tu solicitud. Ventas revisará tu solicitud antes de aprobar la compra.

              //- Datos del cliente y equipo
              .resumen-solicitud-datos
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label Resumen Solicitud
                    span.resumen-dato-value.text-blue R.U.T
                    span.resumen-dato-valor {{ form.rut }}
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label Nombre
                    span.resumen-dato-valor {{ form.nombre }}
                  .resumen-dato
                    span.resumen-dato-label Correo Electrónico
                    span.resumen-dato-valor {{ form.correo }}
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label Apellido
                    span.resumen-dato-valor {{ form.apellido }}
                  .resumen-dato
                    span.resumen-dato-label Teléfono
                    span.resumen-dato-valor {{ form.telefono || '—' }}
                .resumen-dato-row
                  .resumen-dato
                    span.resumen-dato-label.text-blue N° De Serie Equipo
                    span.resumen-dato-valor {{ form.numero_serie }}
                  .resumen-dato
                    span.resumen-dato-label Modelo del Equipo
                    span.resumen-dato-valor {{ modeloSeleccionado ? modeloSeleccionado.nombre : (form.modelo_nuevo_nombre || '—') }}

              //- Productos seleccionados
              .resumen-solicitud-productos
                .resumen-producto(v-if="extensionSeleccionada")
                  .resumen-producto-icon
                    svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                      path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .resumen-producto-info
                    span.resumen-producto-nombre {{ extensionSeleccionada.nombre }}
                    span.resumen-producto-precio.text-blue ${{ Number(extensionSeleccionada.precio).toLocaleString('es-CL') }}
                .resumen-producto(v-if="form.garantia_id === 'no_extension'")
                  .resumen-producto-icon
                    svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                      path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .resumen-producto-info
                    span.resumen-producto-nombre Sin extensión de tiempo
                    span.resumen-producto-precio $0
                .resumen-producto(v-for="p in proteccionesSeleccionadas" :key="p.id")
                  .resumen-producto-icon
                    svg(viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
                      path(d="M12 2L3 7v5c0 5.25 3.83 10.16 9 11.35C17.17 22.16 21 17.25 21 12V7L12 2z" fill="#22c55e")
                      path(d="M9 12l2 2 4-4" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                  .resumen-producto-info
                    span.resumen-producto-nombre {{ p.nombre }}
                    span.resumen-producto-precio.text-blue ${{ Number(p.precio).toLocaleString('es-CL') }}

      //- Columna derecha: Resumen Pago (solo paso 5)
      .resumen-column(v-if="pasoActivo === 5")
        .resumen-pago-card
          h3.resumen-pago-title Resumen Pago

          //- Cupón de descuento (SILL-1537)
          .cupon-seccion
            label.cupon-label Cupón de descuento (opcional)
            .input-group.input-group-cupon
              b-form-input.cupon-input(
                v-model="form.codigo_cupon"
                placeholder="Ingresa el código"
                :state="fieldState('codigo_cupon')"
                :disabled="cuponEstado === 'validando'"
                @keyup.enter="validarCupon"
              )
              .input-group-append
                b-button.btn-validar-cupon(
                  @click="validarCupon"
                  :disabled="!form.codigo_cupon.trim() || cuponEstado === 'validando'"
                )
                  b-spinner(v-if="cuponEstado === 'validando'" small variant="light")
                  b-icon(v-else icon="check2-circle" font-scale="1.2")
            .cupon-estado.mt-1(v-if="cuponEstado === 'valido'")
              b-icon(icon="check-circle-fill" variant="success")
              span.text-success.ml-1 Cupón aplicado: -{{ cuponDescuentoPorcentaje }}%
            .cupon-estado.mt-1(v-else-if="cuponEstado === 'invalido'")
              b-icon(icon="x-circle-fill" variant="danger")
              span.text-danger.ml-1 Cupón no válido o no disponible
            .cupon-estado.mt-1(v-else-if="cuponEstado === 'error'")
              span.text-danger.ml-1 {{ cuponError }}
            b-form-invalid-feedback(v-if="errors.codigo_cupon") {{ errors.codigo_cupon }}

          //- Totales
          .resumen-totales
            .resumen-total-row
              span.resumen-total-label Ítems:
              span.resumen-total-value ${{ totalEstimado.toLocaleString('es-CL') }}
            .resumen-total-row(v-if="descuentoCupon > 0")
              span.resumen-total-label Descuentos:
              span.resumen-total-value.text-success -${{ descuentoCupon.toLocaleString('es-CL') }}
            .resumen-total-row.resumen-total-final
              span.resumen-total-label-final Total:
              span.resumen-total-value-final ${{ subtotalConCupon.toLocaleString('es-CL') }}

          //- Error general
          b-alert(v-if="errorGeneral" show variant="danger" class="mt-3") {{ errorGeneral }}

          //- Botones de acción
          .resumen-acciones
            b-button.btn-resumen-primary(
              :disabled="submitting || !puedeConfirmar"
              @click="handleSubmit"
            )
              b-spinner(v-if="submitting" small class="mr-2")
              | {{ submitting ? 'Creando...' : 'Finalizar OVG' }}
            b-button.btn-resumen-secondary(
              @click="$router.push('/garantias-center')"
            ) Volver atrás

          .text-muted.small.text-right.mt-1(v-if="!puedeConfirmar")
            b-icon(icon="exclamation-circle")
            |  Seleccioná al menos una extensión de tiempo o una protección adicional.

    //- ─── Modal: Crear Nuevo Modelo ─────────────────────────────────────────
    b-modal(
      v-model="showModalModeloNuevo"
      title="Crear nuevo modelo de equipo"
      centered
      hide-footer
      @hidden="onModalModeloHidden"
    )
      b-form-group(label="Nombre del Modelo*" label-class="samtek-label")
        b-form-input(
          v-model="modeloNuevoNombreTemp"
          placeholder=""
          :state="errorModalNombre ? false : null"
          @keyup.enter="confirmarModeloNuevo"
        )
        b-form-invalid-feedback {{ errorModalNombre }}
      .d-flex.justify-content-end.mt-4
        b-button.mr-2(variant="outline-secondary" @click="showModalModeloNuevo = false") Cancelar
        b-button.btn-confirmar-modelo(@click="confirmarModeloNuevo") Crear Modelo
</template>

<script>
import imageCompression from 'browser-image-compression'
import { mapActions } from 'vuex'

const HOY = new Date().toISOString().split('T')[0]
const DIAS_180 = 180

export default {
  name: 'OVGCreateView',

  data() {
    return {
      hoy: HOY,
      // Wizard
      pasoActivo: 1,
      pasoMaxAlcanzado: 1,
      // Formulario
      form: {
        nombre: '',
        apellido: '',
        correo: '',
        rut: '',
        telefono: '',
        numero_serie: '',
        fecha_compra_equipo: '',
        modelo_id: null,
        modelo_nuevo_nombre: '',
        garantia_id: null,
        proteccion_ids: [],
        codigo_cupon: '',
      },
      boletaFile: null,
      boletaPreviewUrl: null,
      boletaDragOver: false,
      // Modelos
      modeloQuery: '',
      modeloResultados: [],
      modeloSeleccionado: null,
      modeloNuevo: false,
      loadingModelos: false,
      modeloSearchTimeout: null,
      // Segmentos (eliminado — el back lo asigna automáticamente)
      // Modal nuevo modelo
      showModalModeloNuevo: false,
      modeloNuevoNombreTemp: '',
      errorModalNombre: '',
      // Extensiones y protecciones
      extensiones: [],
      protecciones: [],
      loadingExtensiones: false,
      loadingProtecciones: false,
      // Cupón de descuento (SILL-1537)
      cuponEstado: '', // '', 'validando', 'valido', 'invalido', 'error'
      cuponDescuentoPorcentaje: 0,
      cuponDescuentoMonto: 0,
      cuponError: '',
      // Estado
      submitting: false,
      errors: {},
      errorGeneral: '',
      resultado: null,
    }
  },

  computed: {
    tieneModelo() {
      return (
        !!this.form.modelo_id ||
        (this.modeloNuevo && !!this.form.modelo_nuevo_nombre.trim())
      )
    },

    boletaEsImagen() {
      if (!this.boletaFile) return false
      return this.boletaFile.type.startsWith('image/')
    },

    // OVG09: equipo reciente = comprado hace ≤ 180 días
    equipoReciente() {
      if (!this.form.fecha_compra_equipo) return false
      const fechaCompra = new Date(this.form.fecha_compra_equipo)
      const hoy = new Date()
      const diffDias = (hoy - fechaCompra) / (1000 * 60 * 60 * 24)
      return diffDias <= DIAS_180
    },

    extensionSeleccionada() {
      return (
        this.extensiones.find((e) => e.id === this.form.garantia_id) || null
      )
    },

    proteccionesSeleccionadas() {
      return this.protecciones.filter((p) =>
        this.form.proteccion_ids.includes(p.id)
      )
    },

    tieneExtension() {
      // 'no_extension' significa que el usuario eligió NO tener extensión de tiempo
      // por tanto no cuenta como "tener extensión" para confirmar sin protección
      return !!this.form.garantia_id && this.form.garantia_id !== 'no_extension'
    },

    tieneProteccion() {
      return this.form.proteccion_ids.length > 0
    },

    tieneSeleccion() {
      return this.tieneExtension || this.tieneProteccion
    },

    puedeConfirmar() {
      if (!this.tieneModelo) return false
      return this.tieneExtension || this.tieneProteccion
    },

    mostrarPaso4() {
      return this.pasoMaxAlcanzado >= 4 && this.equipoReciente
    },

    totalEstimado() {
      let total = 0
      if (this.extensionSeleccionada)
        total += Number(this.extensionSeleccionada.precio)
      this.proteccionesSeleccionadas.forEach((p) => {
        total += Number(p.precio)
      })
      return total
    },

    subtotalConCupon() {
      return this.totalEstimado - this.descuentoCupon
    },

    descuentoCupon() {
      if (this.cuponEstado !== 'valido' || !this.cuponDescuentoPorcentaje)
        return 0
      return Math.round(
        (this.totalEstimado * this.cuponDescuentoPorcentaje) / 100
      )
    },
  },

  methods: {
    ...mapActions('OVGCenterStore', [
      'getModelos',
      'getGarantias',
      'crearOvgManual',
      'validarCuponGarantia',
    ]),

    // --- Navegación wizard ---
    irAPaso(n) {
      if (n <= this.pasoMaxAlcanzado || n === 5) this.pasoActivo = n
    },

    // --- Cupón de descuento (SILL-1537) ---
    async validarCupon() {
      const codigo = this.form.codigo_cupon.trim()
      if (!codigo) return

      this.errors = { ...this.errors, codigo_cupon: undefined }
      this.cuponEstado = 'validando'
      this.cuponError = ''

      try {
        const result = await this.validarCuponGarantia(codigo)
        this.cuponDescuentoPorcentaje = result.porcentaje_descuento
        this.cuponEstado = 'valido'
      } catch (err) {
        const status = err.response && err.response.status
        if (status === 404) {
          this.cuponEstado = 'invalido'
          this.cuponError = 'El código de descuento no es válido.'
        } else {
          this.cuponEstado = 'error'
          this.cuponError =
            '¡Lo sentimos! El código de descuento ya no está disponible.'
        }
        this.cuponDescuentoPorcentaje = 0
      }
    },

    avanzarPaso1() {
      this.errors = {}
      if (!this.form.nombre.trim()) {
        this.errors.nombre = 'El nombre es obligatorio.'
        return
      }
      if (!this.form.apellido.trim()) {
        this.errors.apellido = 'El apellido es obligatorio.'
        return
      }
      if (!this.form.correo.trim()) {
        this.errors.correo = 'El correo es obligatorio.'
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.form.correo.trim())) {
        this.errors.correo = 'Ingresa un correo electrónico válido.'
        return
      }
      if (!this.form.rut.trim()) {
        this.errors.rut = 'El RUT es obligatorio.'
        return
      }
      if (this.pasoMaxAlcanzado < 2) this.pasoMaxAlcanzado = 2
      this.pasoActivo = 2
    },

    avanzarPaso2() {
      this.errors = {}
      if (!this.form.numero_serie.trim()) {
        this.errors.numero_serie = 'El N° de serie es obligatorio.'
        return
      }
      if (this.form.numero_serie.length !== 15) {
        this.errors.numero_serie =
          'El N° de serie debe tener exactamente 15 caracteres.'
        return
      }
      if (!this.tieneModelo) {
        this.errors.modelo_id = 'Selecciona un modelo o indica uno nuevo.'
        return
      }
      if (!this.form.fecha_compra_equipo) {
        this.errors.fecha_compra_equipo = 'La fecha de compra es obligatoria.'
        return
      }
      if (!this.boletaFile) {
        this.errors.boleta_cliente = 'La boleta es obligatoria.'
        return
      }
      if (this.pasoMaxAlcanzado < 3) this.pasoMaxAlcanzado = 3
      this.pasoActivo = 3
    },

    avanzarPaso3() {
      this.errors = {}
      if (!this.form.garantia_id) {
        this.errors.garantia_id = 'Selecciona una extensión.'
        return
      }
      if (this.equipoReciente) {
        // Siempre refresca: si el usuario vuelve a paso 3 y cambia de extensión
        // (o venía de "Sin extensión"), paso 4 debe reflejar el nuevo tiempo
        // total elegido, no quedarse con la lista de la selección anterior.
        if (this.form.modelo_id) {
          this.fetchProtecciones(this.form.modelo_id)
        }
        if (this.pasoMaxAlcanzado < 4) this.pasoMaxAlcanzado = 4
        this.pasoActivo = 4
      } else {
        // Equipo > 180 días: no hay paso 4, ir directo a resumen
        if (this.pasoMaxAlcanzado < 5) this.pasoMaxAlcanzado = 5
        this.irAPaso(5)
      }
    },

    seleccionarSinExtension() {
      // Solo disponible si equipo reciente
      if (!this.equipoReciente) return
      this.form.garantia_id = 'no_extension'
      if (this.form.modelo_id) this.fetchProtecciones(this.form.modelo_id)
      if (this.pasoMaxAlcanzado < 4) this.pasoMaxAlcanzado = 4
      this.pasoActivo = 4
    },

    avanzarPaso4() {
      if (this.pasoMaxAlcanzado < 5) this.pasoMaxAlcanzado = 5
      this.irAPaso(5)
    },

    continuarSinProteccion() {
      // Limpia las protecciones seleccionadas y avanza al resumen
      this.form.proteccion_ids = []
      if (this.pasoMaxAlcanzado < 5) this.pasoMaxAlcanzado = 5
      this.irAPaso(5)
    },

    // --- Extensión ---
    seleccionarExtension(id) {
      this.form.garantia_id = id
    },

    // --- Protección ---
    toggleProteccion(id) {
      const idx = this.form.proteccion_ids.indexOf(id)
      if (idx === -1) {
        this.form.proteccion_ids.push(id)
      } else {
        this.form.proteccion_ids.splice(idx, 1)
      }
    },

    // --- Modelo ---
    onModeloSearch(q) {
      clearTimeout(this.modeloSearchTimeout)
      this.modeloSeleccionado = null
      this.form.modelo_id = null
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
      if (q.length < 2) {
        this.modeloResultados = []
        return
      }
      this.loadingModelos = true
      this.modeloSearchTimeout = setTimeout(async () => {
        try {
          const data = await this.getModelos({ q })
          this.modeloResultados = data.results || []
        } finally {
          this.loadingModelos = false
        }
      }, 350)
    },

    seleccionarModelo(modelo) {
      this.modeloSeleccionado = modelo
      this.form.modelo_id = modelo.id
      this.modeloResultados = []
      this.modeloQuery = modelo.nombre || String(modelo.id)
      this.fetchExtensiones(modelo.id)
    },

    limpiarModelo() {
      this.modeloSeleccionado = null
      this.form.modelo_id = null
      this.modeloQuery = ''
      this.modeloResultados = []
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
    },

    activarModeloNuevo() {
      this.modeloNuevoNombreTemp = ''
      this.errorModalNombre = ''
      this.showModalModeloNuevo = true
    },

    confirmarModeloNuevo() {
      this.errorModalNombre = ''
      if (!this.modeloNuevoNombreTemp.trim()) {
        this.errorModalNombre = 'El nombre del modelo es obligatorio.'
        return
      }
      this.form.modelo_nuevo_nombre = this.modeloNuevoNombreTemp.trim()
      this.form.modelo_id = null
      this.modeloSeleccionado = null
      this.modeloQuery = ''
      this.modeloResultados = []
      this.modeloNuevo = true
      this.showModalModeloNuevo = false
      // Cargar extensiones sin modelo_id
      this.onSegmentoChange()
    },

    onModalModeloHidden() {
      this.errorModalNombre = ''
    },

    cancelarModeloNuevo() {
      this.modeloNuevo = false
      this.form.modelo_nuevo_nombre = ''
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
    },

    // --- Segmento ---
    async onSegmentoChange() {
      this.extensiones = []
      this.protecciones = []
      this.form.garantia_id = null
      this.form.proteccion_ids = []
      this.loadingExtensiones = true
      try {
        this.extensiones = await this.getGarantias({ tipo: 'extension_tiempo' })
      } finally {
        this.loadingExtensiones = false
      }
    },

    // --- Fecha de compra ---
    onFechaCompraChange() {
      if (!this.equipoReciente) {
        this.form.proteccion_ids = []
        this.protecciones = []
        if (this.form.garantia_id === 'no_extension') {
          this.form.garantia_id = null
        }
        // Si ya estaba en paso 4, retroceder a paso 3
        if (this.pasoActivo === 4) {
          this.pasoActivo = 3
          this.pasoMaxAlcanzado = 3
        }
      } else if (this.form.modelo_id) {
        this.fetchProtecciones(this.form.modelo_id)
      }
    },

    // --- Extensiones ---
    async fetchExtensiones(modeloId) {
      this.loadingExtensiones = true
      this.extensiones = []
      this.form.garantia_id = null
      try {
        this.extensiones = await this.getGarantias({
          modeloId,
          tipo: 'extension_tiempo',
        })
      } finally {
        this.loadingExtensiones = false
      }
    },

    // --- Protecciones ---
    async fetchProtecciones(modeloId) {
      this.loadingProtecciones = true
      this.protecciones = []
      this.form.proteccion_ids = []
      try {
        // extensionId: el id real si hay extensión elegida, '' si el usuario
        // fue por "Sin extensión de tiempo". El backend calcula
        // anios_totales = base_warranty_years del modelo + esa extensión
        // (o solo la base si extensionId es '') — única fuente de verdad,
        // ya no se calcula en el front (ver GarantiasDisponiblesView).
        const extensionId = this.tieneExtension ? this.form.garantia_id : ''
        const danos = await this.getGarantias({
          modeloId,
          tipo: 'danos_accidentales',
          extensionId,
        })
        const onsite = await this.getGarantias({
          modeloId,
          tipo: 'atencion_onsite',
          extensionId,
        })
        // Deduplicar por id
        const todos = [...danos, ...onsite]
        const seen = new Set()
        this.protecciones = todos.filter((p) => {
          if (seen.has(p.id)) return false
          seen.add(p.id)
          return true
        })
      } finally {
        this.loadingProtecciones = false
      }
    },

    // --- Boleta ---
    onBoletaDrop(e) {
      this.boletaDragOver = false
      const file = e.dataTransfer && e.dataTransfer.files[0]
      if (!file) return
      this.boletaFile = file
      if (file.type.startsWith('image/')) {
        this.boletaPreviewUrl = URL.createObjectURL(file)
      } else {
        this.boletaPreviewUrl = null
      }
    },

    onBoletaChange(e) {
      const file = e.target.files[0]
      if (!file) {
        this.boletaFile = null
        this.boletaPreviewUrl = null
        return
      }
      this.boletaFile = file
      if (file.type.startsWith('image/')) {
        this.boletaPreviewUrl = URL.createObjectURL(file)
      } else {
        this.boletaPreviewUrl = null
      }
    },

    fieldState(field) {
      if (!Object.keys(this.errors).length) return null
      return this.errors[field] ? false : null
    },

    // --- Submit ---
    async handleSubmit() {
      this.errors = {}
      this.errorGeneral = ''
      this.resultado = null

      if (!this.puedeConfirmar) {
        this.errors.garantias =
          'Seleccioná al menos una extensión de tiempo o una protección adicional.'
        return
      }

      const fd = new FormData()
      fd.append('correo', this.form.correo)
      fd.append('nombre', this.form.nombre)
      fd.append('apellido', this.form.apellido)
      fd.append('rut', this.form.rut)
      if (this.form.telefono) fd.append('telefono', this.form.telefono)
      fd.append('numero_serie', this.form.numero_serie)
      fd.append('fecha_compra_equipo', this.form.fecha_compra_equipo)

      if (this.form.garantia_id && this.form.garantia_id !== 'no_extension') {
        fd.append('garantia_id', this.form.garantia_id)
      }
      this.form.proteccion_ids.forEach((id) => fd.append('proteccion_ids', id))

      let boletaParaEnviar = this.boletaFile
      if (this.boletaEsImagen) {
        boletaParaEnviar = await imageCompression(this.boletaFile, {
          maxSizeMB: 1,
          maxWidthOrHeight: 1280,
          useWebWorker: true,
          fileType: this.boletaFile.type,
        })
      }
      fd.append(
        'boleta_cliente',
        boletaParaEnviar,
        this.boletaFile.name || 'boleta.jpg'
      )

      if (this.form.modelo_id) {
        fd.append('modelo_id', this.form.modelo_id)
      } else {
        fd.append('modelo_nuevo_nombre', this.form.modelo_nuevo_nombre.trim())
      }

      // SILL-1537 — cupón de descuento (opcional)
      if (this.form.codigo_cupon.trim()) {
        fd.append('codigo_cupon', this.form.codigo_cupon.trim())
      }

      this.submitting = true
      try {
        const res = await this.crearOvgManual(fd)
        this.resultado = res
        setTimeout(() => {
          this.$router.push(`/garantias-center/${res.ovg_id}`)
        }, 2000)
      } catch (err) {
        const status = err.response && err.response.status
        const data = (err.response && err.response.data) || {}

        if (status === 409) {
          this.errors.numero_serie =
            'Ya existe una OVG activa para este N° de serie.'
        } else if (status === 502) {
          this.errorGeneral =
            'Error al generar el link de pago (Getnet falló). Revisá los datos e intentá nuevamente.'
        } else if (status === 400) {
          if (typeof data === 'object') {
            const fieldMap = {
              garantia_id: 'garantia_id',
              proteccion_ids: 'garantias',
              fecha_compra_equipo: 'fecha_compra_equipo',
              modelo_id: 'modelo_id',
              modelo_nuevo_nombre: 'modelo_nuevo_nombre',
              numero_serie: 'numero_serie',
              correo: 'correo',
              nombre: 'nombre',
              apellido: 'apellido',
              rut: 'rut',
              telefono: 'telefono',
              boleta_cliente: 'boleta_cliente',
              codigo_cupon: 'codigo_cupon',
            }
            Object.entries(fieldMap).forEach(([apiKey, formKey]) => {
              if (data[apiKey]) {
                this.errors[formKey] = Array.isArray(data[apiKey])
                  ? data[apiKey][0]
                  : data[apiKey]
              }
            })
            if (data.non_field_errors) {
              this.errorGeneral = Array.isArray(data.non_field_errors)
                ? data.non_field_errors[0]
                : data.non_field_errors
            } else if (!Object.keys(this.errors).length) {
              this.errorGeneral =
                data.error ||
                'Error de validación. Revisá los datos ingresados.'
            }
          } else {
            this.errorGeneral =
              'Error de validación. Revisá los datos ingresados.'
          }
        } else {
          this.errorGeneral = 'Error inesperado. Intentá nuevamente.'
        }
      } finally {
        this.submitting = false
      }
    },
  },

  mounted() {},
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.ovg-create-view {
  background-color: #f5f6fa;
  min-height: 100vh;
  padding-bottom: 60px;
}

.container-create {
  padding: 20px;
  max-width: 960px;
  margin: 0 auto;
}

.header-ovg {
  display: flex;
  align-items: center;
  height: 4rem;
  padding: 0 20px;

  .title-section {
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;

    .back-arrow {
      color: $samtek-yellow;
      font-size: 32px;
    }

    .title {
      margin: 0;
      font-weight: bold;
      color: $samtek-black;
    }
  }
}

.breadcrumbs-ovg {
  margin-bottom: 25px;
  font-size: 14px;
  padding: 0 20px;
}

// ── Wizard steps ────────────────────────────────────────────────────────────
.step-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  overflow: hidden;
}

.step-header {
  display: flex;
  align-items: center;
  padding: 18px 24px;
  cursor: pointer;
  user-select: none;
  gap: 14px;

  &.locked {
    cursor: default;
    opacity: 0.5;
  }
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: $samtek-yellow;
  color: $samtek-black;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.done {
    background: #28a745;
    color: #fff;
  }
}

.step-label {
  font-weight: 700;
  font-size: 16px;
  color: #23201c;
  flex: 1;
}

.step-toggle {
  color: #888;
}

.step-body {
  padding: 24px;
}

// ── Modelo con botón ────────────────────────────────────────────────────────
.modelo-grupo {
  margin-top: 12px;

  label {
    display: block;
    margin-bottom: 6px;
  }
}

.btn-crear-modelo {
  white-space: nowrap;
  height: 38px;
  align-self: flex-end;
  background-color: #f5f6fa;
  border-color: #ced4da;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 0 20px;
}

// ── Boleta drag-and-drop ─────────────────────────────────────────────────────
.boleta-dropzone {
  border: 1px dashed #525252;
  border-radius: 5px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: background 0.2s, border-color 0.2s;
  cursor: default;

  &.is-dragover {
    background-color: #fffbea;
    border-color: $samtek-yellow;
  }
}

.boleta-upload-icon {
  color: #1a73e8;
  margin-bottom: 8px;
}

.boleta-upload-text {
  color: #525252;
  font-size: 15px;
}

.btn-seleccionar-boleta {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 6px 20px;

  &:hover {
    background-color: darken($samtek-yellow, 8%);
    border-color: darken($samtek-yellow, 8%);
    color: #23201c;
  }
}

// ── Modelo ─────────────────────────────────────────────────────────────────
.modelo-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modelo-resultados {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  margin-top: 4px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.modelo-item {
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &.selected {
    background-color: #f8f9fa;
    font-weight: 600;
  }
}

.modelo-seleccionado {
  margin-top: 8px;
}

.otro-modelo-box {
  background: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 10px;
  padding: 16px;
  margin-top: 8px;
}

// ── Cards de garantía (extensiones y protecciones) ──────────────────────────
.garantias-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 8px;
}

.garantia-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  text-align: left;
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: $samtek-yellow;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &.selected {
    border-color: $samtek-yellow;
    background: #fffbea;

    .btn-garantia {
      background-color: darken($samtek-yellow, 6%);
      border-color: darken($samtek-yellow, 6%);
    }
  }
}

.garantia-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 10px;
}

.garantia-nombre {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 6px;
  color: #23201c;
}

.garantia-desc {
  font-size: 13px;
  color: #525252;
  margin-bottom: 10px;
  flex: 1;
}

.garantia-precio {
  font-weight: 700;
  font-size: 18px;
  color: #23201c;
  margin-bottom: 10px;
}

.btn-garantia {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;

  &:hover,
  &:focus,
  &:active {
    background-color: darken($samtek-yellow, 8%) !important;
    border-color: darken($samtek-yellow, 8%) !important;
    color: #23201c !important;
    box-shadow: none !important;
  }
}

.btn-step-primary {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 8px 24px;

  &:hover,
  &:focus,
  &:active {
    background-color: darken($samtek-yellow, 8%) !important;
    border-color: darken($samtek-yellow, 8%) !important;
    color: #23201c !important;
    box-shadow: none !important;
  }

  &:disabled {
    background-color: $samtek-yellow;
    border-color: $samtek-yellow;
    opacity: 0.5;
  }
}

// ── Layout 2 columnas (Figma SILL-1536) ──────────────────────────────────────
.create-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.wizard-column {
  flex: 1;
  min-width: 0;
  max-width: 860px;
  margin: 0 auto;
}

.resumen-column {
  width: 320px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;
}

@media (max-width: 1024px) {
  .create-layout {
    flex-direction: column;
  }
  .wizard-column {
    max-width: 100%;
  }
  .resumen-column {
    width: 100%;
    position: static;
  }
}

// ── Resumen Pago Card ──────────────────────────────────────────────────────
.resumen-pago-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.resumen-pago-title {
  font-size: 20px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

// ── Cupón de descuento (SILL-1537) ──────────────────────────────────────────
.cupon-seccion {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cupon-label {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.input-group-cupon {
  .form-control {
    border-radius: 6px 0 0 6px;
    border-color: #d1d5db;
    font-size: 14px;
    height: 40px;

    &:focus {
      border-color: #1d4ed8;
      box-shadow: 0 0 0 0.15rem rgba(29, 78, 216, 0.25);
    }
  }
}

.btn-validar-cupon {
  background-color: #203859;
  border-color: #203859;
  color: #ffffff;
  border-radius: 0 6px 6px 0;
  padding: 0 14px;
  font-weight: 500;
  height: 40px;

  &:hover,
  &:focus,
  &:active {
    background-color: darken(#203859, 8%) !important;
    border-color: darken(#203859, 8%) !important;
    color: #ffffff !important;
  }

  &:disabled {
    background-color: #203859;
    border-color: #203859;
    opacity: 0.5;
  }
}

.cupon-estado {
  font-size: 13px;
  display: flex;
  align-items: center;
}

// ── Totales ────────────────────────────────────────────────────────────────
.resumen-totales {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.resumen-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resumen-total-label {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
}

.resumen-total-value {
  font-size: 14px;
  font-weight: 600;
  color: #23201c;
}

.resumen-total-final {
  border-top: 1px solid #e5e7eb;
  padding-top: 10px;
  margin-top: 4px;
}

.resumen-total-label-final {
  font-size: 18px;
  font-weight: 700;
  color: #203859;
}

.resumen-total-value-final {
  font-size: 22px;
  font-weight: 700;
  color: #203859;
}

// ── Botones resumen ────────────────────────────────────────────────────────
.resumen-acciones {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-resumen-primary {
  background-color: #fece2f;
  border-color: #fece2f;
  color: #23201c;
  font-weight: 500;
  font-size: 15px;
  border-radius: 8px;
  height: 45px;
  padding: 10px 20px;
  width: 100%;

  &:hover,
  &:focus,
  &:active {
    background-color: darken(#fece2f, 8%) !important;
    border-color: darken(#fece2f, 8%) !important;
    color: #23201c !important;
  }

  &:disabled {
    background-color: #fece2f;
    border-color: #fece2f;
    opacity: 0.5;
  }
}

.btn-resumen-secondary {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #23201c;
  font-weight: 500;
  font-size: 15px;
  border-radius: 8px;
  height: 45px;
  padding: 10px 20px;
  width: 100%;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    background-color: #f5f6fa !important;
    border-color: #f5f6fa !important;
    color: #23201c !important;
  }
}

.boleta-img-preview {
  max-width: 100%;
  max-height: 220px;
  border-radius: 8px;
  object-fit: contain;
}

.btn-cambiar-boleta {
  color: #525252;
  font-size: 13px;
}

.btn-confirmar-modelo {
  background-color: $samtek-yellow;
  border-color: $samtek-yellow;
  color: #23201c;
  font-weight: 500;
  border-radius: 8px;
  padding: 6px 20px;

  &:hover {
    background-color: darken($samtek-yellow, 8%);
    border-color: darken($samtek-yellow, 8%);
    color: #23201c;
  }
}

// ── Labels ──────────────────────────────────────────────────────────────────
::v-deep .samtek-label {
  font-weight: 700;
}

// ── Botones ─────────────────────────────────────────────────────────────────
.btn-crear {
  min-width: 160px;
}

.btn-sin-extension,
.btn-continuar-sin-proteccion {
  background-color: #fff;
  border: 1px solid #ced4da;
  color: #23201c;
  font-weight: 400;
  border-radius: 8px;
  margin-top: 8px;

  &:hover:not(:disabled) {
    border-color: $samtek-yellow;
    color: #23201c;
    background-color: #fff;
  }

  &:disabled {
    opacity: 0.45;
  }
}

// ── Resumen de la Solicitud (Paso 5) ────────────────────────────────────────
.resumen-solicitud-body {
  padding: 20px;
}

.resumen-solicitud {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.resumen-solicitud-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.resumen-solicitud-title {
  font-size: 28px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
  font-family: 'Noto Sans', sans-serif;
}

.resumen-solicitud-desc {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
  margin: 0;
  max-width: 660px;
}

// ── Datos del cliente y equipo ─────────────────────────────────────────────
.resumen-solicitud-datos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resumen-dato-row {
  display: flex;
  gap: 24px;
}

.resumen-dato {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 225px;
}

.resumen-dato-wide {
  flex: 1;
}

.resumen-dato-label {
  font-size: 15px;
  font-weight: 700;
  color: #525252;
}

.resumen-dato-label.text-blue {
  color: #1d4ed8;
}

.resumen-dato-value {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
}

.resumen-dato-valor {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
}

// ── Productos seleccionados ────────────────────────────────────────────────
.resumen-solicitud-productos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.resumen-producto {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border: 1px solid #444444;
  border-radius: 4px;
  background: #ffffff;
  height: 80px;
}

.resumen-producto-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #525252;
}

.resumen-producto-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.resumen-producto-nombre {
  font-size: 15px;
  font-weight: 700;
  color: #525252;
}

.resumen-producto-precio {
  font-size: 20px;
  font-weight: 700;
  color: #203859;
}

.text-blue {
  color: #1d4ed8 !important;
}

@media (max-width: 768px) {
  .container-create {
    padding: 12px;
  }
  .garantias-grid {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
